import { Cookie } from "../utils";
import { CustomMode, STORAGE } from "../constants";
import ThemeManger from "../services/theme-manager";

let memoUserKey = "";
let memoCustom = "";

export function getCustomInfo() {
  if (memoUserKey && memoCustom) {
    return {
      cumtomMode: memoUserKey,
      userKey: memoCustom,
    };
  }
  const res = localStorage.getItem(STORAGE.CUSTOM);
  if (res) {
    const [cumtomMode, userKey] = res.split("|");
    return {
      cumtomMode,
      userKey,
    };
  } else {
    return {
      cumtomMode: "",
      userKey: "",
    };
  }
}

export function checkMigu() {
  return ThemeManger.isMigu;
}
